ClubCalendarController.$inject = [
    '$scope',
    'Club',
    'Time',
    '_',
    'alerts',
    'User',
    'Backoffice',
];

/* @ngInject */
function ClubCalendarController(
    $scope,
    Club,
    Time,
    _,
    alerts,
    User,
    Backoffice,
) {
    var vm = this;
    vm.title = 'ClubCalendarController';
    vm.loading = true;

    vm.calendar_date = new Date();
    // Calendar settings
    vm.calendar_options = {
        customClass: getDayClass,
        minDate: new Date(),
        showWeeks: false,
    };
    vm.calendar_data = {};

    vm.selected_events = [];

    vm.courts = {};

    vm.new_event = default_event();
    vm.typeToText = function (type) {
        switch (type) {
            case 0:
                return 'CERRADO';
            case 1:
                return 'FERIADO';
        }
    };

    vm.typeToColor = function (type) {
        switch (type) {
            case 0:
                return 'orange';
            case 1:
                return 'green';
        }
    };

    vm.store = function () {
        alerts
            .verifyCode(null, null, User)
            .then(store)
            .catch((error) => {
                alerts.errorHandler(error);
            });
    };

    vm.remove = function (event_id, court_id) {
        alerts
            .confirm(
                'Borrar evento del calendario',
                '¿Estás seguro que querés borrar ese/esos eventos?',
            )
            .then(function () {
                alerts
                    .verifyCode(null, null, User)
                    .then(remove.bind(this, event_id, court_id))
                    .catch((error) => {
                        alerts.errorHandler(error);
                    });
            });
    };

    $scope.$watch('vm.calendar_date', checkEventsForDate);

    activate();

    ////////////////

    function activate() {
        Club.API.getList('courts', {
            full: false,
        }).then(function (courts) {
            courts = courts.plain();
            vm.courts = _.zipObject(_.map(courts, 'id'), _.map(courts, 'name'));
        });

        fetchCalendar();
    }

    async function fetchCalendar(date = null) {
        vm.loading = true;
        let calendarData = {};

        let events;
        try {
            events = await Backoffice.api.getSpecialEvents({});
        } catch (error) {
            handleError(error);
            vm.loading = false;
            return;
        }

        events.closed.forEach((event) => {
            calendarData[event.date] ?? (calendarData[event.date] = []);
            if (event?.court_ids?.length) {
                event.court_ids.forEach((court) => {
                    calendarData[event.date].push({
                        id: event.id,
                        court_id: court,
                        date: event.date,
                        sportclub_id: event.id.split(':')[1],
                        type: 0,
                    });
                });
            } else
                calendarData[event.date].push({
                    id: event.id,
                    court_id: event?.court_ids ? event.court_ids : '',
                    date: event.date,
                    sportclub_id: event.id.split(':')[1],
                    type: 0,
                });
        });
        events.holidays.forEach((event) => {
            calendarData[event.date] ?? (calendarData[event.date] = []);
            calendarData[event.date].push({
                id: event.id,
                court_id: [],
                date: event.date,
                sportclub_id: event.id.split(':')[1],
                type: 1,
            });
        });

        vm.calendar_data = calendarData;
        checkEventsForDate(vm.calendar_date);
        vm.selected_events =
            vm.calendar_data[
                Time.moment(vm.calendar_date).format('YYYY-MM-DD')
            ];
        vm.loading = false;
        vm.calendar_options = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: false,
        };
        Club.API.one('calendar').customGET();

        /*
        Club.API.one('calendar')
            .customGET()
            .then(function (calendar) {
                vm.calendar_data = sortCalendarData(calendar);
                console.log(vm.calendar_data)
                //checkEventsForDate(vm.calendar_date);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
            */
    }

    function sortCalendarData(raw) {
        return raw;
    }

    function getDayClass(data) {
        var date = Time.moment(data.date).format('Y-MM-DD'),
            mode = data.mode;

        if (
            mode === 'day' &&
            vm.calendar_data.hasOwnProperty(date) &&
            vm.calendar_data[date].length > 0
        ) {
            var type = vm.calendar_data[date][0].type;
            return vm.typeToColor(type) + '-bottom';
        }

        return '';
    }

    function checkEventsForDate(date) {
        const formatted_date = Time.moment(date).format('YYYY-MM-DD');
        if (vm.calendar_data.hasOwnProperty(formatted_date)) {
            vm.selected_events = vm.calendar_data[formatted_date];
            vm.loading = false;
            vm.loading_new = false;
            return;
        }

        vm.loading = false;
        vm.loading_new = false;
        vm.selected_events = [];
    }

    function default_event() {
        return {
            type: 1,
            court_id: [],
            with_courts: false,
        };
    }

    function store({ code }) {
        vm.loading_new = true;
        var data = {
            code: code,
            date: Time.moment(vm.calendar_date).format('Y-MM-DD'),
            type: vm.new_event.type,
        };

        if (
            vm.new_event.type !== 1 &&
            vm.new_event.with_courts &&
            vm.new_event.court_id.length
        ) {
            data.court_id = vm.new_event.court_id;
        }

        if (vm.new_event.type === 0) {
            const formattedDate = Time.moment(vm.calendar_date).format(
                'YYYY-MM-DD',
            );

            function createEvent() {
                const payload = {
                    date: formattedDate,
                    court_ids: data.court_id || undefined,
                };
                const existingEvents = vm.calendar_data[formattedDate] || [];
                const existingClosed = existingEvents.find((e) => e.type === 0);
                const eventHasCourts =
                    existingClosed && existingClosed.court_id?.length > 0;
                const isClubClosed =
                    !data.court_id || data.court_id.length === 0;
                if (eventHasCourts && isClubClosed) {
                    return Backoffice.api
                        .deleteSpecialEvent({
                            id: existingClosed.id,
                        })
                        .then(function () {
                            return Backoffice.api.createSpecialEventClosed(
                                payload,
                            );
                        });
                }
                return Backoffice.api.createSpecialEventClosed(payload);
            }

            createEvent()
                .then(function (event) {
                    console.log('event created', event);
                    if (!event.court_ids?.length) {
                        vm.calendar_data[formattedDate] = [
                            {
                                id: event.id,
                                court_id: event.court_ids
                                    ? event.court_ids
                                    : [],
                                date: event.date,
                                sportclub_id: event.id.split(':')[1],
                                type: 0,
                            },
                        ];
                    } else {
                        vm.calendar_data[formattedDate] = event.court_ids.map(
                            (court) => ({
                                id: event.id,
                                court_id: court,
                                date: event.date,
                                sportclub_id: event.id.split(':')[1],
                                type: 0,
                            }),
                        );
                    }
                    checkEventsForDate(formattedDate);
                    vm.new_event = default_event();
                })
                .catch(handleError)
                .finally(function () {
                    fetchCalendar(formattedDate);
                    checkEventsForDate(formattedDate);
                    vm.selected_events = vm.calendar_data[formattedDate];
                    vm.loading_new = false;
                    Club.API.one('calendar').customGET();
                });
        } else if (vm.new_event.type === 1) {
            Backoffice.api
                .createSpecialEventHolidays({
                    date: Time.moment(vm.calendar_date).format('YYYY-MM-DD'),
                })
                .then(function (event) {
                    console.log('event created', event);
                    vm.calendar_data[
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD')
                    ] = [
                        {
                            id: event.id,
                            date: event.date,
                            sportclub_id: event.id.split(':')[1],
                            type: 1,
                        },
                    ];
                    checkEventsForDate(vm.calendar_date);
                    vm.new_event = default_event();
                })
                .catch(handleError)
                .finally(function () {
                    fetchCalendar(
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD'),
                    );
                    checkEventsForDate(
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD'),
                    );

                    vm.loading_new = false;
                    Club.API.one('calendar').customGET();
                });
        }

        /*
        Club.API.one('calendar')
            .customPOST(data)
            .then(function (calendars) {
                if (!vm.calendar_data.hasOwnProperty(data.date)) {
                    vm.calendar_data[data.date] = [];
                }
                vm.calendar_data[data.date] = vm.calendar_data[data.date].concat(calendars);
                checkEventsForDate(vm.calendar_date);
                vm.new_event = default_event();
            })
            .catch(handleError)
            .finally(function () {
                vm.loading_new = false;
            });
        */
    }

    function remove(id_event, court_id, { code }) {
        vm.loading_new = true;

        Backoffice.api
            .deleteSpecialEvent({
                id: id_event,
            })
            .then(function () {
                vm.loading_new = false;
                console.log('event deleted');
                //si tengo una cancha tengo borrar y agregar de nuevo las que tenia
                if (typeof court_id === 'string') {
                    vm.calendar_data[
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD')
                    ] = vm.calendar_data[
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD')
                    ].filter((event) => event.court_id !== court_id);
                    const courts_id = vm.calendar_data[
                        Time.moment(vm.calendar_date).format('YYYY-MM-DD')
                    ]
                        .filter((event) => typeof event.court_id === 'string')
                        .map((event) => event.court_id);

                    if (courts_id.length) {
                        Backoffice.api
                            .createSpecialEventClosed({
                                date: Time.moment(vm.calendar_date).format(
                                    'YYYY-MM-DD',
                                ),
                                court_ids: courts_id,
                            })
                            .then(function (event) {
                                console.log('event created');
                            })
                            .catch(handleError)
                            .finally(function () {
                                fetchCalendar(
                                    Time.moment(vm.calendar_date).format(
                                        'YYYY-MM-DD',
                                    ),
                                );
                                vm.loading_new = false;
                                Club.API.one('calendar').customGET();
                            });
                    }
                }
            })
            .catch(handleError)
            .finally(function () {
                fetchCalendar(
                    Time.moment(vm.calendar_date).format('YYYY-MM-DD'),
                );
                vm.loading_new = false;
                Club.API.one('calendar').customGET();
            });

        /*
        Club.API.one('calendar')
            .customDELETE(date, data)
            .then(function (calendar) {
                vm.calendar_data[date] = calendar;
                vm.selected_events = calendar;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading_new = false;
            });
        */
    }

    function handleError(error) {
        if (error && error.data && error.data.error) {
            return alerts.errorHandler(error);
        }

        const message =
            error && error.message
                ? error.message
                : 'No pudimos completar la operación. Intentá nuevamente.';
        alerts.error('¡Error!', message);
        return error;
    }
}

export default ClubCalendarController;
